/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull ampli_approved_backend_event'
 *
 * Required dependencies: @amplitude/analytics-node@^1.0.0
 * Tracking Plan Version: 107
 * Build: 1.0.0
 * Runtime: node.js:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./implementation/ampli_approved_backend_event)
 */

import * as amplitude from '@amplitude/analytics-node';

export type NodeClient = amplitude.Types.NodeClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
export type NodeOptions = amplitude.Types.NodeOptions;

export type Environment = 'default';

export const ApiKey: Record<Environment, string> = {
  default: 'e77e0b640b2cbe43ff235bbf62d75947'
};

/**
* Default Amplitude configuration options. Contains tracking plan information.
*/
export const DefaultConfiguration: NodeOptions = {
  plan: {
    version: '107',
    branch: 'main',
    source: 'ampli_approved_backend_event',
    versionId: '38e7a37e-c4b5-4e7e-bca5-7950efbbff74'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'node.js-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: NodeOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: NodeOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: NodeClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  /**
   * Name of the Customer Success Manager assigned to the matched Salesforce account.
   */
  account_csm?: string;
  /**
   * Whether the matched Salesforce account currently has an open opportunity.
   */
  account_has_open_opportunity?: boolean;
  /**
   * Account tier based on total enrollment across the full district hierarchy. Use for territory planning and market sizing.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Enterprise, MidMarket, Small Business, Self Serve/Digital, Strategic |
   */
  account_hierarchy_tier?: "Enterprise" | "MidMarket" | "Small Business" | "Self Serve/Digital" | "Strategic";
  /**
   * Type of educational institution associated with the Salesforce account.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | district, public school, private school, catholic school, state school, county school, county office, regional center, cmo, diocese, bia school, state dept, unknown |
   */
  account_institution_type?:
    | "district"
    | "public school"
    | "private school"
    | "catholic school"
    | "state school"
    | "county school"
    | "county office"
    | "regional center"
    | "cmo"
    | "diocese"
    | "bia school"
    | "state dept"
    | "unknown";
  /**
   * Date of the last logged Salesforce activity on the account (ISO 8601: YYYY-MM-DD). Use for identifying accounts with no recent sales touch.
   */
  account_last_activity_date?: string;
  /**
   * Salesforce account name matched to the user's email domain.
   */
  account_name?: string;
  /**
   * Name of the Account Executive who owns the matched Salesforce account.
   */
  account_owner?: string;
  /**
   * Current lifecycle phase of the Salesforce account.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | New, Activating, Onboarding, Adopting, Renewal, SAA, SQA, MQA, Advocacy, Recycle |
   */
  account_phase?:
    | "New"
    | "Activating"
    | "Onboarding"
    | "Adopting"
    | "Renewal"
    | "SAA"
    | "SQA"
    | "MQA"
    | "Advocacy"
    | "Recycle";
  /**
   * Name of the Regional Vice President responsible for the matched Salesforce account.
   */
  account_rvp?: string;
  /**
   * Sales territory region of the matched Salesforce account.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Northeast, Southeast, Central, West |
   */
  account_sales_region?: "Northeast" | "Southeast" | "Central" | "West";
  /**
   * Name of the Sales Development Rep assigned to the matched Salesforce account.
   */
  account_sdr?: string;
  /**
   * Level of CS engagement and treatment for the matched Salesforce account. Reflects CS coverage model, not account size.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Enterprise, MidMarket, Small Business, Self Serve/Digital, Strategic |
   */
  account_service_tier?: "Enterprise" | "MidMarket" | "Small Business" | "Self Serve/Digital" | "Strategic";
  /**
   * Salesforce account status — whether the account is a current customer or prospect.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Customer, Prospect, Former Customer, Pilot |
   */
  account_status?: "Customer" | "Prospect" | "Former Customer" | "Pilot";
  /**
   * Whether the user has completed the activation milestone (first meaningful generation).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Initiated, Activated |
   */
  activation_stage?: "Initiated" | "Activated";
  authentication_provider?: string;
  community?: string;
  created_at?: string;
  /**
   * Subject area or department inferred from the user's profile.
   */
  department?: string;
  /**
   * MDR student enrollment count for the matched district (source of truth for district size).
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  district_account_enrollment?: number;
  /**
   * Salesforce ID of the district account matched to this user.
   */
  district_account_id?: string;
  /**
   * Name of the district Salesforce account matched to this user.
   */
  district_account_name?: string;
  /**
   * Whether the user signed up with a work or personal email domain.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | work, personal |
   */
  domain_type?: "work" | "personal";
  /**
   * Classification of the user's email address (e.g. personal, work, edu).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | work, personal |
   */
  email_type?: "work" | "personal";
  /**
   * Usage-based engagement tier computed from generation activity. None = registered but never generated. Power/Core = highest engagement.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | None, Infrequent, Casual, Core, Power |
   */
  engagement_status?: "None" | "Infrequent" | "Casual" | "Core" | "Power";
  /**
   * Facebook Click ID. Set on the user's last touch when a visitor arrives via a Facebook or Instagram Ads click. Used for Meta attribution and conversion matching. Populated by GTM on the marketing site. See also: initial_fbclid (first-touch).
   */
  fbclid?: string;
  /**
   * Date the user ran their first AI generation (ISO 8601: YYYY-MM-DD). Use as cohort anchor and user tenure reference.
   */
  first_generation_date?: string;
  /**
   * Google Click ID for app conversions (iOS, privacy-safe). Set on the user's last touch when a visitor arrives via a Google Ads click on iOS with SKAdNetwork attribution. Used alongside gclid for Google paid search attribution. The derived property has_paid_search_click_id is true when this or gclid, msclkid, or wbraid is set. See also: initial_gbraid (first-touch).
   */
  gbraid?: string;
  /**
   * Google Click ID. Set on the user's last touch when a visitor arrives via a Google Ads click. Used to attribute sessions to Google paid search campaigns. Populated by GTM on the marketing site. The derived property has_paid_search_click_id is true when this or msclkid, gbraid, or wbraid is set. See also: initial_gclid (first-touch).
   */
  gclid?: string;
  /**
   * Grade level band the user primarily teaches.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | PK, K-5, 6-8, 9-12, K-8, K-12, 6-12 |
   */
  grade_band?: "PK" | "K-5" | "6-8" | "9-12" | "K-8" | "K-12" | "6-12";
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  grades?: string[];
  /**
   * First-touch Kochava Click ID. Set once on the user's first marketing touchpoint when they arrive via a Kochava-tracked link. Used to attribute the user's acquisition to programmatic or affiliate campaigns tracked through Kochava. The derived property has_programmatic_click_id is true when this is set. Not overwritten on subsequent visits.
   */
  initial_ko_click_id?: string;
  /**
   * Whether the user's Salesforce account has an active Educator Guidance product in its CW Opportunity Products rollup (Salesforce `EG_Included_in_Active_CW_Opp_Products__c`). `true`/`false` when the user has a matched Salesforce account; absent (no value) when the user has no associated Salesforce account.
   */
  is_educator_guidance_purchased?: boolean;
  /**
   * Whether the user's organization has purchased the Learning Outcomes Module (LOM), based on the org-level `enable_lom_purchased` attribute in the product database. `true`/`false` when the user's org is known; absent (no value) when the user has no associated organization.
   */
  is_learning_outcomes_module_purchased?: boolean;
  /**
   * Whether the user's organization has MagicStudent enabled, based on the org-level `enable_magic_student` attribute in the product database. `true`/`false` when the user's org is known; absent (no value) when the user has no associated organization.
   */
  is_magicstudent_enabled?: boolean;
  /**
   * LinkedIn First-Party Ad Tracking ID. Set on the user's last touch when a visitor arrives via a LinkedIn Ads click. Used to attribute sessions to LinkedIn paid social campaigns. The derived property has_paid_social_click_id is true when this or ttclid or twclid is set. See also: initial_li_fat_id (first-touch).
   */
  li_fat_id?: string;
  /**
   * Monthly active user lifecycle status as of the last daily refresh.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new, retained, resurrected, churned |
   */
  mau_status?: "new" | "retained" | "resurrected" | "churned";
  /**
   * Salesforce contact membership type (e.g. Pioneer, Ambassador).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Pioneer, Ambassador |
   */
  member_type?: "Pioneer" | "Ambassador";
  /**
   * Microsoft (Bing) Click ID. Set on the user's last touch when a visitor arrives via a Microsoft Advertising (Bing Ads) click. Used to attribute sessions to Bing paid search campaigns. The derived property has_paid_search_click_id is true when this or gclid, gbraid, or wbraid is set. See also: initial_msclkid (first-touch).
   */
  msclkid?: string;
  /**
   * Name of the MagicSchool org the user currently belongs to.
   */
  org_name?: string;
  /**
   * Type of MagicSchool org the user belongs to.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | School, District, Organization, Group |
   */
  org_type?: "School" | "District" | "Organization" | "Group";
  /**
   * Role persona inferred from profession and title. Used for segmentation and targeting.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Educators, Principals, Instructional Leaders, School System Leads, Tech Leaders, Ed Tech Coordinators, Other |
   */
  persona?:
    | "Educators"
    | "Principals"
    | "Instructional Leaders"
    | "School System Leads"
    | "Tech Leaders"
    | "Ed Tech Coordinators"
    | "Other";
  /**
   * The user's current MagicSchool plan.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | free, partner, plus |
   */
  plan_name?: "free" | "partner" | "plus";
  /**
   * Seniority level inferred from title. Complements persona for TAM targeting.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Staff, Director, Specialist, Executive, Mid, Other |
   */
  rank?: "Staff" | "Director" | "Specialist" | "Executive" | "Mid" | "Other";
  /**
   * Reactivation funnel stage for previously churned users who have returned.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | None, Initiated, Activated |
   */
  reactivation_stage?: "None" | "Initiated" | "Activated";
  /**
   * City of the matched school.
   */
  school_city?: string;
  /**
   * Student enrollment at the matched school.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  school_enrollment?: number;
  /**
   * Grade-level classification of the matched school (e.g. elementary, middle, high).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | PK, K-5, 6-8, 9-12, K-8, K-12, 6-12, Higher Ed |
   */
  school_level?: "PK" | "K-5" | "6-8" | "9-12" | "K-8" | "K-12" | "6-12" | "Higher Ed";
  /**
   * Name of the school matched to the user via institution resolution.
   */
  school_name?: string;
  /**
   * Two-letter state code of the matched school.
   */
  school_state?: string;
  /**
   * Number of teachers at the matched school.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  school_teachers?: number;
  /**
   * Type of school (e.g. public, private, charter) from institution data.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | public_k12, private_k12, college |
   */
  school_type?: "public_k12" | "private_k12" | "college";
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  subjects?: string[];
  /**
   * All individual grade levels the user teaches (e.g. ['3','4','5']).
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  teacher_grades?: string[];
  /**
   * All subjects the user teaches (e.g. ['Math','Science/STEM']).
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  teacher_subjects?: string[];
  /**
   * TikTok Click ID. Set on the user's last touch when a visitor arrives via a TikTok Ads click. Used to attribute sessions to TikTok paid social campaigns. The derived property has_paid_social_click_id is true when this or li_fat_id or twclid is set. See also: initial_ttclid (first-touch).
   */
  ttclid?: string;
  /**
   * Twitter/X Click ID. Set on the user's last touch when a visitor arrives via a Twitter/X Ads click. Used to attribute sessions to Twitter/X paid social campaigns. The derived property has_paid_social_click_id is true when this or li_fat_id or ttclid is set. See also: initial_twclid (first-touch).
   */
  twclid?: string;
  /**
   * Registered email domain of the ultimate parent Salesforce account.
   */
  ultimate_parent_account_domain?: string;
  /**
   * Salesforce ID of the top-level account in the hierarchy (e.g. the state DOE or CMO).
   */
  ultimate_parent_account_id?: string;
  /**
   * Name of the top-level Salesforce account in the hierarchy.
   */
  ultimate_parent_account_name?: string;
  /**
   * Last-touch UTM campaign name. Identifies the specific campaign (e.g., back-to-school-2025, district-q3) from the user's most recent touchpoint. Set by GTM on the marketing site from the utm_campaign query parameter. Used for campaign-level performance reporting. See also: initial_utm_campaign (first-touch).
   */
  utm_campaign?: string;
  /**
   * Last-touch UTM content. Differentiates ads or links within the same campaign (e.g., banner-a, cta-blue). Used for A/B testing creative variants and link placement. Set by GTM on the marketing site from the utm_content query parameter. See also: initial_utm_content (first-touch).
   */
  utm_content?: string;
  /**
   * Last-touch UTM campaign ID. A numeric or alphanumeric identifier for the campaign, used to link Amplitude data back to ad platform campaign records. Set by GTM on the marketing site from the utm_id query parameter. See also: initial_utm_id (first-touch).
   */
  utm_id?: string;
  /**
   * Last-touch UTM medium. Identifies the marketing channel type (e.g., cpc, email, social) from the user's most recent touchpoint. Set by GTM on the marketing site from the utm_medium query parameter. Used alongside utm_source in the Marketing Channel classifier. See also: initial_utm_medium (first-touch).
   */
  utm_medium?: string;
  /**
   * Last-touch UTM source. Identifies the traffic source (e.g., google, facebook, beehiiv) from the user's most recent marketing touchpoint. Set by GTM on the marketing site from the utm_source query parameter. Used as the primary dimension in the Marketing Channel classifier. See also: initial_utm_source (first-touch).
   */
  utm_source?: string;
  /**
   * Last-touch UTM term. Captures the paid search keyword that triggered the ad click (e.g., ai lesson plan generator). Set by GTM on the marketing site from the utm_term query parameter. Primarily used for Google and Bing paid search keyword reporting. See also: initial_utm_term (first-touch).
   */
  utm_term?: string;
  /**
   * Google Click ID for web conversions (iOS, privacy-safe). Set on the user's last touch when a visitor arrives via a Google Ads click on iOS with web-to-app attribution. Used alongside gclid for Google paid search attribution. The derived property has_paid_search_click_id is true when this or gclid, msclkid, or gbraid is set. See also: initial_wbraid (first-touch).
   */
  wbraid?: string;
  "Words Generated"?: string;
}

export interface AlertRecipientAddedProperties {
  /**
   * The institution (school) id when recipient_scope_type is school; absent for org_wide.
   */
  institution_id?: string;
  /**
   * The org the recipient was added to.
   */
  org_id?: string;
  /**
   * Whether the moderation alert recipient covers the whole org (org_wide) or one specific school (school).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | org_wide, school |
   */
  recipient_scope_type?: "org_wide" | "school";
}

export interface AlertRecipientRemovedProperties {
  /**
   * The institution (school) id when recipient_scope_type is school; absent for org_wide.
   */
  institution_id?: string;
  /**
   * The org the recipient was removed from.
   */
  org_id?: string;
  /**
   * Whether the moderation alert recipient covers the whole org (org_wide) or one specific school (school).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | org_wide, school |
   */
  recipient_scope_type?: "org_wide" | "school";
}

export interface ImageLimitHitImpressionProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Surface where the image was generated. It is used in event segmentation and filtering across image-generation-related events, including Image Limit Hit Impression, Image Reported, Image Exported, and Image Gen Upgrade Action.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | in_thread, presentation_studio, image_tool, studio_document |
   */
  image_source: "in_thread" | "presentation_studio" | "image_tool" | "studio_document";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  plan?: number;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface InternalAdminDemoOrgExitedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * role used to access impersonation
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | teacher_persistent, org_admin_persistent, teacher_temporary, org_admin_temporary, student_temporary, site_admin_temporary |
   */
  access_role:
    | "teacher_persistent"
    | "org_admin_persistent"
    | "teacher_temporary"
    | "org_admin_temporary"
    | "student_temporary"
    | "site_admin_temporary";
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
}

export interface InternalAdminEtmStudentRoomTemplateCreatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * The ID for an organization allowing for tracking which organization is impacted, or which organization a user (affected/acting) is part of.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  organization_id: string;
  preview_room_id: string;
  /**
   * UUID of a user.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  user_id?: string;
}

export interface PrintableGeneratedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * **Document artifact (if output was a document otherwise null)**
   */
  document_id: string;
  /**
   * Grade level from the Printables form exactly as selected (e.g. 2nd-grade). Kept separate from grade_level, which holds K-2 / 3-5 / 6-8 / 9-12 bands. Absent when the form had no grade.
   */
  printables_grade_level?: string;
  /**
   * Number of pages in the printable set: pages planned on a new printable, or 1 for a revision.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  printables_page_count: number;
  /**
   * Number of planned pages whose image could not be generated, so were left out of the document.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  printables_pages_failed: number;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface PrintableGenerationFailedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * Why no image was made: usage_limit (image limit reached), blocked (safety checks refused the request), no_access (no image generation access), failed (any other error).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | usage_limit, blocked, no_access, failed |
   */
  failure_reason: "usage_limit" | "blocked" | "no_access" | "failed";
  /**
   * document_first_response when making a new printable failed; document_refinement when revising a page from the image's Edit button failed. Same values as on Document Generated.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | document_first_response, document_refinement |
   */
  generation_type: "document_first_response" | "document_refinement";
  /**
   * Grade level from the Printables form exactly as selected (e.g. 2nd-grade). Kept separate from grade_level, which holds K-2 / 3-5 / 6-8 / 9-12 bands. Absent when the form had no grade.
   */
  printables_grade_level?: string;
  /**
   * Number of pages in the printable set: pages planned on a new printable, or 1 for a revision.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  printables_page_count: number;
  /**
   * Specifies the unique tool identifier (e.g. image-generator, tool-recommendations)
   */
  tool_slug: string;
}

export interface PageProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AlertRecipientAdded implements BaseEvent {
  event_type = 'Alert Recipient Added';

  constructor(
    public event_properties?: AlertRecipientAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AlertRecipientRemoved implements BaseEvent {
  event_type = 'Alert Recipient Removed';

  constructor(
    public event_properties?: AlertRecipientRemovedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ImageLimitHitImpression implements BaseEvent {
  event_type = 'Image Limit Hit Impression';

  constructor(
    public event_properties: ImageLimitHitImpressionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminDemoOrgExited implements BaseEvent {
  event_type = 'Internal Admin Demo Org Exited';

  constructor(
    public event_properties: InternalAdminDemoOrgExitedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InternalAdminEtmStudentRoomTemplateCreated implements BaseEvent {
  event_type = 'Internal Admin ETM Student Room Template Created';

  constructor(
    public event_properties: InternalAdminEtmStudentRoomTemplateCreatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PrintableGenerated implements BaseEvent {
  event_type = 'Printable Generated';

  constructor(
    public event_properties: PrintableGeneratedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PrintableGenerationFailed implements BaseEvent {
  event_type = 'Printable Generation Failed';

  constructor(
    public event_properties: PrintableGenerationFailedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: NodeClient;

  get client(): NodeClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already initialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }

    return this.amplitude!.identify(amplitudeIdentify, options);
  }

  /**
   * Track event
   *
   * @param userId The user's id.
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(userId: string | undefined, event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    return this.amplitude!.track(event, undefined, options);
  }

  flush(): PromiseResult<void> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Alert Recipient Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Alert%20Recipient%20Added)
   *
   * An org-wide or school-scoped moderation alert email recipient was added.
   *
   * @param userId The user's ID.
   * @param properties The event's properties (e.g. institution_id)
   * @param options Amplitude event options.
   */
  alertRecipientAdded(
    userId: string | undefined,
    properties?: AlertRecipientAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(userId, new AlertRecipientAdded(properties), options);
  }

  /**
   * Alert Recipient Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Alert%20Recipient%20Removed)
   *
   * An org-wide or school-scoped moderation alert email recipient was removed.
   *
   * @param userId The user's ID.
   * @param properties The event's properties (e.g. institution_id)
   * @param options Amplitude event options.
   */
  alertRecipientRemoved(
    userId: string | undefined,
    properties?: AlertRecipientRemovedProperties,
    options?: EventOptions,
  ) {
    return this.track(userId, new AlertRecipientRemoved(properties), options);
  }

  /**
   * Image Limit Hit Impression
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Image%20Limit%20Hit%20Impression)
   *
   * Tracks when a user asks for an image but the user has reached their image gen usage limit for the day/week (depending on their plan)
   *
   * @param userId The user's ID.
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  imageLimitHitImpression(
    userId: string | undefined,
    properties: ImageLimitHitImpressionProperties,
    options?: EventOptions,
  ) {
    return this.track(userId, new ImageLimitHitImpression(properties), options);
  }

  /**
   * Internal Admin Demo Org Exited
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20Demo%20Org%20Exited)
   *
   * A Demo Org accessed using impersonation has been exited
   *
   * @param userId The user's ID.
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminDemoOrgExited(
    userId: string | undefined,
    properties: InternalAdminDemoOrgExitedProperties,
    options?: EventOptions,
  ) {
    return this.track(userId, new InternalAdminDemoOrgExited(properties), options);
  }

  /**
   * Internal Admin ETM Student Room Template Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Internal%20Admin%20ETM%20Student%20Room%20Template%20Created)
   *
   * A student room template has been created by the enablement of a tool sent through an invitation by the Enterprise Tools Manager
   *
   * @param userId The user's ID.
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  internalAdminEtmStudentRoomTemplateCreated(
    userId: string | undefined,
    properties: InternalAdminEtmStudentRoomTemplateCreatedProperties,
    options?: EventOptions,
  ) {
    return this.track(userId, new InternalAdminEtmStudentRoomTemplateCreated(properties), options);
  }

  /**
   * Printable Generated
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Printable%20Generated)
   *
   * A Printables tool run finished and wrote at least one print-ready page to a Studio document. Sent from the server after the pages are written.
   *
   * @param userId The user's ID.
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  printableGenerated(
    userId: string | undefined,
    properties: PrintableGeneratedProperties,
    options?: EventOptions,
  ) {
    return this.track(userId, new PrintableGenerated(properties), options);
  }

  /**
   * Printable Generation Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/magicschoolai/Magic%20School%20Inc./events/main/latest/Printable%20Generation%20Failed)
   *
   * A printable could not be made or revised: the teacher hit an image limit, the request was blocked by safety checks, the teacher has no image generation access, or generation failed. Sent from the server.
   *
   * @param userId The user's ID.
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  printableGenerationFailed(
    userId: string | undefined,
    properties: PrintableGenerationFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(userId, new PrintableGenerationFailed(properties), options);
  }
}

export const ampli = new Ampli();
